/** @jsxImportSource @emotion/react */

import { CommonIcons } from "assets/common/icons";
import HelmetCustom from "components/common/HelmetCustom";
import { formatCurrency } from "helpers/formatCurrency";
import { useAppDispatch } from "hooks/app-hook";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import { selectBalance, selectBalanceLoading } from "store/user";
import { getMemberBalance } from "store/user/user.thunk";

import Marquee from "../HomePage/Marquee";
import { MemberCenterPageStyle } from "./index.style";
import MemberMenu from "./MemberMenu";

const MemberCenterPage = () => {
  const dispatch = useAppDispatch();
  const username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";
  const { total } = useSelector(selectBalance);
  const isLoading = useSelector(selectBalanceLoading);

  const refreshBalance = () => {
    if (isLoading) return;
    dispatch(getMemberBalance({ username }));
  };

  useEffect(() => {
    if (total) {
      return;
    }
    dispatch(getMemberBalance({ username }));
  }, []);

  return (
    <div css={MemberCenterPageStyle.self}>
      <HelmetCustom title="Member center" />
      <Marquee />
      <div css={MemberCenterPageStyle.balanceBlock}>
        <h1 css={MemberCenterPageStyle.title}>Trung tâm hội viên</h1>
        <div css={MemberCenterPageStyle.balance}>
          {`Số dư tài khoản ${formatCurrency(total)}`}
          <CommonIcons.Refresh
            css={MemberCenterPageStyle.refreshIcon}
            onClick={refreshBalance}
            data-loading={isLoading && "loading"}
          />
        </div>
      </div>
      <MemberMenu />
    </div>
  );
};

export default MemberCenterPage;
